import React from 'react'
import Dropdown from 'react-bootstrap/Dropdown';
import { Navigate, useNavigate } from 'react-router-dom';
import { useEyeconxStore } from '../../store/eyeconxStore';
function Header() {
    const logout  = useEyeconxStore((state)=>state.logout)
    const navigate = useNavigate();
  const handleLogout = ()=>{
       // console.log("Logging Out")
        logout();
        navigate("/login");
  }
  const handleToggleSidebar = () =>{
    
  }
  return (
    <>
     <header className="header fixed-top d-flex align-items-center">
            
            <div className="d-flex align-items-center justify-content-between">
                <a href="#" className="logo d-flex align-items center">
                    <span className="d-none d-lg-block">EyeconX</span>
                </a>
               
                
            </div>
           

             <nav className="header-nav ms-auto">
                 <ul className="d-flex align-items-center">
                     <li className="nav-item d-block d-lg-none">
                         <a href="#" className="nav-link nav-icon search-bar-toogle">
                             <i className="bi bi-search"></i>
                         </a>
                     </li>

                     
                     <li className="nav-item dropdown pe-3">
                       
                         <Dropdown>
                             <Dropdown.Toggle size="sm"  variant="secondary" id="dropdown-basic">
                                 <i className="bi bi-person"></i>
                             </Dropdown.Toggle>
                             <Dropdown.Menu>
                                 <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                             </Dropdown.Menu>
                         </Dropdown>
                     </li>

                 </ul>
             </nav>


         </header>
    </>
  )
}

export default Header